import orderprint from "../../screens/orderprint";
import { actiontype } from "../actions/masteractions";

const initialState = {
  scale: [],
  location: [],
  orderprint: [],
  machine_meter_master: [],
};

export const masterreducers = (state = initialState, action: any) => {
  switch (action.type) {
    case actiontype.GET_SCALE:
      return {
        ...state,
        scale: action.payload,
      };
    case actiontype.GET_LOCATION:
      return {
        ...state,
        location: action.payload,
      };
    case actiontype.ORDER_PRINT:
      return {
        ...state,
        orderprint: action.payload,
      };
    case actiontype.GET_MACHINE_METER_MASTER:
      return {
        ...state,
        machine_meter_master: action.payload,
      };
    default:
      return state;
  }
};

export default masterreducers;
